import { render, staticRenderFns } from "./action-document-ckeditor.vue?vue&type=template&id=8d723e3a"
import script from "./action-document-ckeditor.vue?vue&type=script&lang=js"
export * from "./action-document-ckeditor.vue?vue&type=script&lang=js"
import style0 from "./action-document-ckeditor.vue?vue&type=style&index=0&id=8d723e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports